/**
 * 
 * Shared functionality to use in ShapeJS related forms.
 * 
 */

var ShapewaysView = require('js/lib/views/ShapewaysView');
var sw            = require('js/lib/sw');
var _             = require('underscore');

var AJAX_STATUS_SUCCESS = 'success';

var ShapeJsForm = ShapewaysView.extend({

  /**
   * Initiates polling model processing after a GenerateShapeJSModel request.
   * @param  {object} response Response data from GenerateShapeJSModel.
   */
  pollModelProcessing: function(response) {
    if (response.result === AJAX_STATUS_SUCCESS) {
      var pollingData = response.data.pollingData;
      sw.polling(pollingData.endpoint, function(data) {
        sw.trigger(pollingData.event, data);
      });
    }

    var notyData = response.data.messageOptions;
    _.extend(notyData, {
      timeout: !_.isUndefined(notyData.timeout) ? notyData.timeout : false
    });

    sw.notifications.displayNoty(response.data.message, notyData);
  }
});

module.exports = ShapeJsForm;
